import React from "react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-zinc-800/60 bg-[#33101C]">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="mb-3"><Logo size="sm" /></div>
            <p className="text-sm text-zinc-400">The city doesn't sleep. Neither do we. Gigs, sets, sets of jokes — all after hours.</p>
          </div>
          <div>
            <h4 className="mb-3 font-mono text-xs uppercase tracking-wider text-amber-400">Discover</h4>
            <ul className="space-y-2 text-sm text-zinc-400"><li>Music</li><li>Comedy</li><li>Sports</li><li>Nightlife</li></ul>
          </div>
          <div>
            <h4 className="mb-3 font-mono text-xs uppercase tracking-wider text-amber-400">For Organizers</h4>
            <ul className="space-y-2 text-sm text-zinc-400"><li>Host an event</li><li>Promote in the spotlight</li><li>Wednesday payouts</li><li>Analytics</li></ul>
          </div>
          <div>
            <h4 className="mb-3 font-mono text-xs uppercase tracking-wider text-amber-400">Company</h4>
            <ul className="space-y-2 text-sm text-zinc-400"><li>About</li><li>Careers</li><li>Contact</li><li>Terms</li></ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-zinc-800/60 pt-6 text-xs text-zinc-500 sm:flex-row sm:items-center">
          <div>© {new Date().getFullYear()} Afterhours. All rights reserved.</div>
          <div className="font-mono uppercase tracking-widest">5% booking fee + GST · secure payments</div>
        </div>
      </div>
    </footer>
  );
}
